import { CircularProgress, Grid, IconButton, Tooltip, useTheme } from "@mui/material";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { getsignedDocumentContractRequest, getsignedDocumentRequest } from "../../../api/s10DocumentsApi";
import { setDocumentContract, setDocumentSignature, setRecordSignature } from "../../../api/signalApi";
import {
    CONTRACT_DOCUMENT_SIGNATURE_REQUEST,
    PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST,
    RECORD_DOCUMENT_SIGNATURE_REQUEST
} from "../../../constants/signalRequestConsts";
import DrawRoundedIcon from '@mui/icons-material/DrawRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MySnackbar from "../../../components/MySnackbar";
import { setSigninRequestStatus } from "../../../store/slices/documents";
import DocumentViewer from "../../../components/DocumentViewer";
import { getPresignedUrlRequest } from "../../../api/fileStorage";


interface SignDocument {
    NroFs: string;
    FirmaTop: string;
    FirmadoFecha: string;
    IdDocument: string;
    requestId: typeof PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST | typeof RECORD_DOCUMENT_SIGNATURE_REQUEST |  typeof CONTRACT_DOCUMENT_SIGNATURE_REQUEST
    FirmaLeft?: string;
    FirmaPagePosition?: string;
    ruc?: string;
    userDocument?: string;
    documentType?: string;
    documentNumber?: string;
    signButton?: boolean;
    signDisabled?: boolean;
    minWidth?: string;
    onSignDocument?: (idDocument: any) => void;
    isContract?: boolean
}


// interface DownloadButtonDocumentProps extends SignDocument {
//     setErrorMsg: (value: string) => void;
// }

const DownloadButtonDocument = ({
    NroFs,
    FirmaTop,
    FirmaLeft,
    FirmaPagePosition,
    IdDocument,
    FirmadoFecha,
    requestId,
    ruc,
    userDocument,
    documentType,
    documentNumber,
    signButton,
    signDisabled,
    minWidth,
    onSignDocument,
    isContract,
}: SignDocument) => {

    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();

    const auth = useSelector((state: RootState) => state.auth);
    const {signinRequestStatus} = useSelector((state: RootState) => state.documents);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [urlFile, setUrlFile] = useState<string>("");


    const downloadDocument = async (signDocument: boolean) => {
        setLoading(true)
        console.log("starting download")
        const token = auth.companyselected?.Token as any;
        // TODO: add signDocument validation
        let secondsToWait = 0;
        let signId = requestId === RECORD_DOCUMENT_SIGNATURE_REQUEST ? requestId : IdDocument;
        if (!FirmadoFecha && requestId !== CONTRACT_DOCUMENT_SIGNATURE_REQUEST) {
            secondsToWait = 1000;
            console.log("signing document")
            const FullName = auth.sessionData?.FullName as any;
            let resp: any;
            resp = await getsignedDocumentRequest(token, NroFs, FirmaTop, FullName);
            if (resp?.status !== 200) {
                setErrorMsg("Ocurrio un error firmando tu archivo, por favor reintenta.")
                setLoading(false)
                return;
            }
            console.log("saving signature")
            if (requestId === RECORD_DOCUMENT_SIGNATURE_REQUEST) {
                await setRecordSignature(
                    ruc as any, 
                    userDocument as any,
                    documentType as any, 
                    documentNumber as any, 
                    requestId
                );
            } else {
                setDocumentSignature(IdDocument, requestId);
            }
        }
        console.log("getting presigned url")
        const resp = await getPresignedUrlRequest(token, NroFs);
        console.log("end getting presigned url")
        if (resp?.data?.Value) {
            const fileData = resp.data.Value;
            console.log("opening file...")
            setTimeout(() => {
                // window.open(fileData.Presigned_url, '_blank', `type=${fileData.ContentType}`);
                setUrlFile(fileData.Presigned_url);
                if (!FirmadoFecha && onSignDocument && requestId !== CONTRACT_DOCUMENT_SIGNATURE_REQUEST) {
                    onSignDocument(signId);
                }
            }, secondsToWait);
            
            
        } else {
            console.log(resp?.data)
            setErrorMsg(resp?.data?.Message || "Error descargando el archivo, por favor reintenta.")
        }
        setLoading(false)
    }

    const signContract = async () => {
        if (requestId === CONTRACT_DOCUMENT_SIGNATURE_REQUEST) {
            dispatch(setSigninRequestStatus('REQUESTING'));
            const token = auth.companyselected?.Token as any;
            const FullName = auth.sessionData?.FullName as any;
            console.log("signing document")
            const resp = await getsignedDocumentContractRequest(token, NroFs, FirmaTop, FirmaLeft as any, FirmaPagePosition as any, FullName, isContract);
            if (resp?.status !== 200) {
                dispatch(setSigninRequestStatus(null));
                setErrorMsg("Ocurrio un error firmando tu archivo, por favor reintenta.")
                setLoading(false)
                return;
            }
            console.log("saving sign document")
            await setDocumentContract(IdDocument, requestId);
        }
    }

    return (
        <Grid container direction="row" minWidth={minWidth ? minWidth : "5rem"}>
        {NroFs && 
            <Tooltip 
                title="Ver documento"
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -14],
                        },
                      },
                    ],
                  },
                }}
            >
                <IconButton
                    disabled={loading || signinRequestStatus === "REQUESTING"}
                    aria-label="Ver documento"
                    onClick={!loading && signinRequestStatus !== "REQUESTING" 
                                ? () => downloadDocument(signButton !== true) 
                                : undefined
                    }
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || signinRequestStatus === "REQUESTING"
                        ? <CircularProgress color="primary" size="1rem" />
                        : <VisibilityIcon />
                    }
                </IconButton >
            </Tooltip>
        }
        {NroFs && !FirmadoFecha && signButton && 
            <Tooltip 
                title={signDisabled ? "Documento observado" : "Firmar documento"}
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -14],
                        },
                      },
                    ],
                  },
                }}
            >
                <IconButton
                    disabled={loading || signinRequestStatus === "REQUESTING"}
                    aria-label="Firmar documento"
                    onClick={!loading && signinRequestStatus !== "REQUESTING" 
                                ? () => signContract() 
                                : undefined 
                    }
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                    }}
                >
                    {loading || signinRequestStatus === "REQUESTING"
                        ? <CircularProgress color="primary" size="1rem" />
                        : <DrawRoundedIcon />
                    }
                </IconButton>
            </Tooltip>
        }
        <MySnackbar
            open={errorMsg !== ""}
            msg={errorMsg}
            severity="error"
            onClose={() =>  setErrorMsg("")}
        />
        <MySnackbar
            open={signinRequestStatus === 'COMPLETED'}
            msg={"Documento firmado"}
            severity="success"
            onClose={() =>  dispatch(setSigninRequestStatus(null))}
        />
        <DocumentViewer
            handleClose={() => setUrlFile("")}
            documentUrl={urlFile}
        />
        </Grid>
    )
}

export default DownloadButtonDocument;